import { Injector } from '@angular/core';
import {
  beneficiaryFormCopCheck,
  onBeneficiaryAddressCredentialsConfirm,
  onBeneficiaryBankCredentialsConfirm,
} from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/beneficiary-form/beneficiary-form-actions.utils';
import { functionCtaType } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/cta-button-actions.utils';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { addEditBeneficiary } from '../domestic-payments/add-beneficiary';

export const beneficiaryFormActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.BENEFICIARY_FORM_BANK_PROCEED,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onBeneficiaryBankCredentialsConfirm(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_ADDRESS_PROCEED,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onBeneficiaryAddressCredentialsConfirm(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_SUBMIT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      addEditBeneficiary(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_COP,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      beneficiaryFormCopCheck(injector, attri.widgetProperties);
    },
  ],
]);
